export default __webpack_public_path__ + "static/media/Icons_Auto_Wallet_Topup.8c3656b2.svg";